import React from 'react';
import Svg from '../../Svg/Svg';
import { SvgProps } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="48"
      height="48"
      viewBox="0 0 129 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.9153 128C13.531 128 16.1466 128 18.7611 128C48.9217 128 79.0812 128 109.241 128C111.857 128 114.472 128 117.087 128C118.592 128 120.097 128 121.601 128C122.106 128.001 122.593 127.944 123.083 127.827C123.32 127.77 123.55 127.701 123.779 127.618C124.699 127.284 125.451 126.805 126.141 126.11C126.238 126.013 126.332 125.912 126.422 125.809C126.85 125.318 127.186 124.793 127.45 124.198C127.458 124.182 127.464 124.165 127.472 124.148C127.604 123.843 127.711 123.533 127.795 123.212C127.797 123.203 127.799 123.195 127.801 123.186C127.936 122.662 128.001 122.141 128.001 121.6C128.001 117.334 128.001 113.067 128.001 108.8C128.001 74.6666 128.001 40.5334 128.001 6.40025C128.001 2.86568 125.136 0.000549316 121.601 0.000549316C120.097 0.000549316 118.592 0.000549316 117.087 0.000549316C115.872 0.000549316 114.657 0.000549316 113.442 0.000549316C113.407 0.000549316 113.374 0.000549316 113.34 0.000549316C113.29 0.000549316 113.24 0.000549316 113.191 0.000549316C111.874 0.000549316 110.558 0.000549316 109.241 0.000549316C79.0807 0.000549316 48.9211 0.000549316 18.7605 0.000549316C17.4442 0.000549316 16.1274 0.000549316 14.8105 0.000549316C14.7608 0.000549316 14.7112 0.000549316 14.6615 0.000549316C14.6271 0.000549316 14.5937 0.000549316 14.5598 0.000549316C13.3446 0.000549316 12.1293 0.000549316 10.9141 0.000549316C9.40928 0.000549316 7.90457 0.000549316 6.40032 0.000549316C2.86519 0.000549316 0 2.86625 0 6.40025C0 40.534 0 74.6672 0 108.8C0 113.067 0 117.334 0 121.6C0 125.135 2.86519 128 6.40032 128C7.90569 128 9.41052 128 10.9153 128Z"
        fill="#E3E3E3"
      />
      <path
        opacity="0.2"
        d="M19.6017 0C19.3217 0 19.0417 0 18.7617 0C17.4455 0 16.1286 0 14.8123 0C14.7626 0 14.7124 0 14.6628 0C14.6289 0 14.5951 0 14.5612 0C13.3459 0 12.1307 0 10.916 0C9.41119 0 7.90635 0 6.40154 0C2.86641 0 0.0012207 2.8657 0.0012207 6.3997C0.0012207 40.5334 0.0012207 74.6666 0.0012207 108.8C0.0012207 113.066 0.0012207 117.333 0.0012207 121.6C0.0012207 125.134 2.86641 127.999 6.40154 127.999C7.90635 127.999 9.41119 127.999 10.916 127.999C13.5311 127.999 16.1467 127.999 18.7612 127.999C19.0412 127.999 19.3211 127.999 19.6011 127.999V0H19.6017Z"
        fill="url(#paint0_linear_6150_22432)"
      />
      <path
        opacity="0.2"
        d="M108.402 0C108.682 0 108.961 0 109.241 0C110.558 0 111.875 0 113.191 0C113.241 0 113.291 0 113.34 0C113.375 0 113.408 0 113.442 0C114.658 0 115.873 0 117.088 0C118.592 0 120.097 0 121.602 0C125.137 0 128.002 2.8657 128.002 6.3997C128.002 40.5334 128.002 74.6666 128.002 108.8C128.002 113.066 128.002 117.333 128.002 121.6C128.002 125.134 125.137 127.999 121.602 127.999C120.097 127.999 118.592 127.999 117.088 127.999C114.472 127.999 111.857 127.999 109.242 127.999C108.962 127.999 108.682 127.999 108.402 127.999V0H108.402Z"
        fill="url(#paint1_linear_6150_22432)"
      />
      <path
        d="M108.002 107.68C108.002 78.5596 108.002 49.4398 108.002 20.3201C108.002 20.0937 107.908 20 107.682 20C78.5612 20 49.4415 20 20.3217 20C20.0953 20 20.0017 20.0937 20.0017 20.3201C20.0017 49.4398 20.0017 78.5602 20.0017 107.68C20.0017 107.906 20.0953 108 20.3217 108C49.442 108 78.5618 108 107.682 108C107.908 108 108.002 107.906 108.002 107.68Z"
        fill="#E3E3E3"
      />
      <path
        d="M20.2557 20C20.0751 20 20 20.075 20 20.2568C20 49.6862 20 79.115 20 108.544C20 108.725 20.0751 108.8 20.2557 108.8C49.6851 108.8 79.1139 108.8 108.543 108.8C108.725 108.8 108.8 108.725 108.8 108.544C108.8 79.115 108.8 49.6862 108.8 20.2568C108.8 20.075 108.725 20 108.543 20C79.1139 20 49.6845 20 20.2557 20Z"
        fill="#575756"
      />
      <path
        d="M108.144 20.6559V20.4002H20.6565"
        stroke="#010202"
        strokeWidth="0.2835"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M108.144 20.4002C108.324 20.4002 108.399 20.4753 108.399 20.6559C108.399 49.8195 108.399 78.9813 108.399 108.144C108.399 108.325 108.324 108.4 108.144 108.4C78.9807 108.4 49.8183 108.4 20.6558 108.4C20.4752 108.4 20.4001 108.325 20.4001 108.144C20.4001 78.9819 20.4001 49.8195 20.4001 20.6559C20.4001 20.4753 20.4752 20.4002 20.6558 20.4002"
        fill="#E3E3E3"
      />
      <path
        d="M64.3995 95.2795C81.4537 95.2795 95.2789 81.4543 95.2789 64.4001C95.2789 47.3458 81.4537 33.5206 64.3995 33.5206C47.3452 33.5206 33.52 47.3458 33.52 64.4001C33.52 81.4543 47.3452 95.2795 64.3995 95.2795Z"
        fill="url(#paint2_linear_6150_22432)"
      />
      <path
        d="M49.0398 68.9602C51.5583 68.9602 53.6 66.9186 53.6 64.4001C53.6 61.8817 51.5583 59.84 49.0398 59.84C46.5214 59.84 44.4797 61.8817 44.4797 64.4001C44.4797 66.9186 46.5214 68.9602 49.0398 68.9602Z"
        fill="#3C3C3B"
      />
      <path
        d="M79.7596 68.9602C82.2781 68.9602 84.3197 66.9186 84.3197 64.4001C84.3197 61.8816 82.2781 59.84 79.7596 59.84C77.2411 59.84 75.1995 61.8816 75.1995 64.4001C75.1995 66.9186 77.2411 68.9602 79.7596 68.9602Z"
        fill="#3C3C3B"
      />
      <path
        d="M97.0681 98.4229C96.656 98.8361 96.656 99.5055 97.0681 99.9187C97.4824 100.333 98.1496 100.33 98.5627 99.9175C98.9765 99.5055 98.977 98.8361 98.5638 98.4229C98.1512 98.0109 97.4812 98.0109 97.0681 98.4229Z"
        fill="#575756"
      />
      <path
        d="M94.0529 98.691C93.3208 98.691 92.5887 98.691 91.8566 98.691C91.7274 98.691 91.6749 98.6379 91.6749 98.5092C91.6749 96.7442 91.6749 94.9792 91.6749 93.2142C91.6749 93.085 91.7279 93.0325 91.8566 93.0325C93.6216 93.0325 95.3867 93.0325 97.1517 93.0325C97.2804 93.0325 97.3328 93.0855 97.3334 93.2142C97.3334 93.9463 97.3334 94.6784 97.3334 95.4116C97.3334 95.7514 97.4734 95.8914 97.8132 95.8914C98.153 95.8914 98.2941 95.7514 98.2941 95.4116C98.2941 94.6784 98.2941 93.9463 98.2941 93.2142C98.293 92.5837 97.7822 92.0735 97.1522 92.0724C95.3872 92.0724 93.6222 92.0724 91.8572 92.0724C91.2268 92.0724 90.7153 92.5837 90.7153 93.2142C90.7153 94.9792 90.7153 96.7442 90.7153 98.5092C90.7153 99.1397 91.2268 99.6511 91.8572 99.6511C92.5893 99.6511 93.3214 99.6511 94.0535 99.6511C94.3921 99.6511 94.5332 99.5112 94.5332 99.1714C94.5332 98.8316 94.391 98.691 94.0529 98.691Z"
        fill="#575756"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6150_22432"
          x1="16.5601"
          y1="64.0001"
          x2="0.309183"
          y2="64.0001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6150_22432"
          x1="111.444"
          y1="63.9998"
          x2="127.694"
          y2="63.9998"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6150_22432"
          x1="64.3995"
          y1="95.28"
          x2="64.3995"
          y2="33.52"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6C6C6" />
          <stop offset="0.2003" stopColor="#C0C0C0" />
          <stop offset="0.5079" stopColor="#AFAFAF" />
          <stop offset="0.8825" stopColor="#929291" />
          <stop offset="1" stopColor="#878787" />
        </linearGradient>
      </defs>
    </Svg>
  );
};

export default Icon;
